module.exports = __webpack_public_path__ + "static/media/armor_background.d8edf9b7.jpg";